import { render, staticRenderFns } from "./PatientDispensingStage.vue?vue&type=template&id=1562f074"
import script from "./PatientDispensingStage.vue?vue&type=script&lang=js"
export * from "./PatientDispensingStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports